import React from "react";
import {
  GiveawayActive,
  GiveawayArchieve,
  FormattedPrizeRange,
} from "../../../../types";
import styles from "../../../GiveawayDetails/GiveawayDetails.module.css";

import firstPlaceArchieve from "/1placeArchieve.svg";
import secondPlaceArchieve from "/2placeArchieve.svg";
import thirdPlaceArchieve from "/3placeArchieve.svg";
import { NFTAnimation } from "../NFTAnimation/NFTAnimation";
import { Reward } from "../../../../../../Components/Reward/Reward";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import dreamcoinLogo from "/DC_coin.svg";
import CharacterLogo from "/character-circle-gold.svg";

interface GiveawayPrizesPropsArchieve {
  giveaway: GiveawayActive | GiveawayArchieve;
  formattedPrizes: FormattedPrizeRange[];
  userID: number;
  openNFTDetails: (detail: string) => void;
  formatNumber: (num: number) => string;
  getRewardType: (type: string) => "dc" | "ticket" | "character" | "USDT";
}

const GiveawayPrizesArchieve: React.FC<GiveawayPrizesPropsArchieve> = ({
  giveaway,
  formattedPrizes,
  userID,
  openNFTDetails,
  formatNumber,
  getRewardType,
}) => {
  return (
    <>
      <div className={styles.topWinnerContainer}>
        <div className={styles.notMain}>
          <div className={styles.relativePosition}>
            <div className={styles.secondPlaceWrapper}>
              {(giveaway as GiveawayArchieve).winners[1]?.photo_url ? (
                <img
                  className={styles.secondPlaceImg}
                  src={(giveaway as GiveawayArchieve).winners[1]?.photo_url}
                  alt=""
                />
              ) : (
                <div className={styles.secondPlaceImg}>
                  {(giveaway as GiveawayArchieve).winners[1]?.full_name
                    ?.charAt(0)
                    .toUpperCase() || "?"}
                </div>
              )}
            </div>
            <img
              src={secondPlaceArchieve}
              alt=""
              className={styles.placeIcon}
            />
          </div>
          <div
            className={styles.notMainText}
            onClick={() =>
              formattedPrizes[1].type === "TelegramNFT"
                ? openNFTDetails(formattedPrizes[1].urls!.detail)
                : undefined
            }
          >
            <div className={styles.notMainName}>
              {giveaway.status !== "active" &&
                (giveaway as GiveawayArchieve).winners[1]?.full_name}
            </div>
            {formattedPrizes[1].type === "TelegramNFT" &&
            formattedPrizes[1].urls ? (
              <div className={styles.nftPrize}>
                <NFTAnimation
                  urls={formattedPrizes[1].urls}
                  status={giveaway.status}
                  place={2}
                />
                <div className={styles.nftNameFinished}>
                  {formattedPrizes[1].name}
                </div>
              </div>
            ) : (
              <Reward
                showType={
                  formattedPrizes[1].type === "Character" ? true : false
                }
                type={getRewardType(formattedPrizes[1].type)}
                amount={formatNumber(formattedPrizes[1].amount)}
              />
            )}
          </div>
        </div>
        <div className={styles.main}>
          <div className={styles.relativePosition}>
            <div className={styles.firstPlaceWrapper}>
              <div className={styles.winnerLightsWrapper}>
                <DotLottieReact
                  src={new URL("/ray-winner.lottie", import.meta.url).href}
                  autoplay
                  loop
                  className={styles.winnerLights}
                />
              </div>
              {(giveaway as GiveawayArchieve).winners[0]?.photo_url ? (
                <img
                  className={styles.firstPlaceImg}
                  src={(giveaway as GiveawayArchieve).winners[0]?.photo_url}
                  alt=""
                />
              ) : (
                <div className={styles.firstPlaceImg}>
                  {(giveaway as GiveawayArchieve).winners[0]?.full_name
                    ?.charAt(0)
                    .toUpperCase() || "?"}
                </div>
              )}
            </div>
            <img
              src={firstPlaceArchieve}
              alt=""
              className={`${styles.placeIcon} ${styles.firstPlaceIcon}`}
            />
          </div>
          <div
            className={styles.notMainText}
            onClick={() =>
              formattedPrizes[0].type === "TelegramNFT"
                ? openNFTDetails(formattedPrizes[0].urls!.detail)
                : undefined
            }
          >
            <div className={styles.notMainName}>
              {giveaway.status !== "active" &&
                (giveaway as GiveawayArchieve).winners[0]?.full_name}
            </div>
            {formattedPrizes[0].type === "TelegramNFT" &&
            formattedPrizes[0].urls ? (
              <div className={styles.nftPrize}>
                <NFTAnimation
                  urls={formattedPrizes[0].urls}
                  status={giveaway.status}
                  place={1}
                />
                <div className={styles.nftNameFinished}>
                  {formattedPrizes[0].name}
                </div>
              </div>
            ) : (
              <Reward
                showType={
                  formattedPrizes[0].type === "Character" ? true : false
                }
                type={getRewardType(formattedPrizes[0].type)}
                amount={formatNumber(formattedPrizes[0].amount)}
              />
            )}
          </div>
        </div>
        <div className={styles.notMain}>
          <div className={styles.relativePosition}>
            <div className={styles.thirdPlaceWrapper}>
              {(giveaway as GiveawayArchieve).winners[2]?.photo_url ? (
                <img
                  className={styles.thirdPlaceImg}
                  src={(giveaway as GiveawayArchieve).winners[2]?.photo_url}
                  alt=""
                />
              ) : (
                <div className={styles.thirdPlaceImg}>
                  {(giveaway as GiveawayArchieve).winners[2]?.full_name
                    ?.charAt(0)
                    .toUpperCase() || "?"}
                </div>
              )}
            </div>
            <img src={thirdPlaceArchieve} alt="" className={styles.placeIcon} />
          </div>
          <div
            className={styles.notMainText}
            onClick={() =>
              formattedPrizes[2].type === "TelegramNFT"
                ? openNFTDetails(formattedPrizes[2].urls!.detail)
                : undefined
            }
          >
            <div className={styles.notMainName}>
              {giveaway.status !== "active" &&
                (giveaway as GiveawayArchieve).winners[2]?.full_name}
            </div>
            {formattedPrizes[2].type === "TelegramNFT" &&
            formattedPrizes[2].urls ? (
              <div className={styles.nftPrize}>
                <NFTAnimation
                  urls={formattedPrizes[2].urls}
                  status={giveaway.status}
                  place={3}
                />
                <div className={styles.nftNameFinished}>
                  {formattedPrizes[2].name}
                </div>
              </div>
            ) : (
              <Reward
                showType={
                  formattedPrizes[2].type === "Character" ? true : false
                }
                type={getRewardType(formattedPrizes[2].type)}
                amount={formatNumber(formattedPrizes[2].amount)}
              />
            )}
          </div>
        </div>
      </div>
      <div className={styles.lightCircle}></div>
      <div className={styles.otherWinnersContainer}>
        {formattedPrizes.map((prize: FormattedPrizeRange, prizeIndex: number) =>
          typeof prize.place === "string" ? (
            <React.Fragment key={prizeIndex}>
              <div className={styles.otherWinnersInfo}>
                <div className={styles.otherWinnersInfoPlace}>
                  {prize.place}
                  <span className={styles.otherWinnersInfoPlaceSpan}>
                    Место
                  </span>
                </div>
                <div className={styles.otherWinnersInfoPrize}>Награда</div>
              </div>
              {giveaway.status !== "active" &&
                (() => {
                  const [start, end] = prize.place.split("-").map(Number);
                  const rangeWinners = (giveaway as GiveawayArchieve).winners
                    .filter((w) => w.place >= start && w.place <= end)
                    .sort((a, b) => a.place - b.place);

                  return rangeWinners.map((winner, winnerIndex) => (
                    <div
                      className={
                        winner.user_id === userID
                          ? styles.otherWinnerSelected
                          : styles.otherWinner
                      }
                      key={`${prizeIndex}-${winnerIndex}`}
                    >
                      <div className={styles.otherWinnerInfo}>
                        {winner.photo_url ? (
                          <img
                            src={winner.photo_url}
                            alt=""
                            className={styles.otherWinnerPhoto}
                          />
                        ) : (
                          <div className={styles.otherWinnerPhoto}>
                            {winner.full_name?.charAt(0).toUpperCase() || "?"}
                          </div>
                        )}
                        <div className={styles.otherWinnerName}>
                          {winner.full_name &&
                            (winner.full_name.length > 15
                              ? `${winner.full_name.slice(0, 15)}...`
                              : winner.full_name)}
                        </div>
                      </div>
                      <div className={styles.otherWinnerPrize}>
                        <div className={styles.otherWinnerReward}>
                          {prize.type === "DC"
                            ? formatNumber(prize.amount)
                            : "Легендарный"}
                        </div>
                        <img
                          className={styles.otherWinnerRewardLogo}
                          src={
                            prize.type === "DC" ? dreamcoinLogo : CharacterLogo
                          }
                          alt=""
                        />
                      </div>
                    </div>
                  ));
                })()}
            </React.Fragment>
          ) : null
        )}
      </div>
    </>
  );
};

export default GiveawayPrizesArchieve;
